// Events — conciertos y eventos en el viaje
import { Link } from "react-router-dom";
import { ChevronLeft, ExternalLink, Calendar, MapPin } from "lucide-react";
import { formatDate } from "../data/helpers";
import { useTripBase } from "../hooks/useTripBase";
import { useTrip } from "../auth/TripContext";

export default function Events() {
  const base = useTripBase();
  const { trip } = useTrip();
  const events = trip?.events || [];
  return (
    <div className="container-app pt-6 pb-28" data-testid="events-page">
      <Link to={base || "/"} className="inline-flex items-center gap-1 text-sm text-[hsl(var(--muted))] mb-4" data-testid="events-back">
        <ChevronLeft size={16} /> Inicio
      </Link>
      <h1 className="text-3xl font-bold leading-tight">Eventos & conciertos</h1>
      <p className="text-sm text-[hsl(var(--muted))] mt-1 mb-5">Sugerencias para tus fechas — confirmen disponibilidad antes de comprar</p>

      {events.length === 0 && (
        <div className="card-paper p-5 text-center">
          <p className="text-sm text-[hsl(var(--muted))]">Aún no hay eventos cargados para este viaje.</p>
        </div>
      )}

      <ul className="space-y-3">
        {events.map((e, i) => (
          <li key={i} className="card-paper p-4" data-testid={`event-${i}`}>
            <div className="flex items-center gap-2 flex-wrap mb-2">
              <span className="chip-ink">{e.city}</span>
              <span className="text-xs text-[hsl(var(--muted))] flex items-center gap-1">
                <Calendar size={11} /> {formatDate(e.date)} {e.time && `· ${e.time}`}
              </span>
            </div>
            <h3 className="font-bold text-base leading-tight mb-1">{e.title}</h3>
            <p className="text-xs text-[hsl(var(--muted))] flex items-center gap-1 mb-2">
              <MapPin size={11} /> {e.where}
            </p>
            <p className="text-sm text-[hsl(var(--ink-soft))] leading-relaxed">{e.note}</p>
            {e.url && (
              <a
                href={e.url.startsWith("http") ? e.url : `https://${e.url}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 text-xs font-medium text-[hsl(var(--accent))] mt-2"
                data-testid={`event-url-${i}`}
              >
                {e.url} <ExternalLink size={11} />
              </a>
            )}
          </li>
        ))}
      </ul>

      <p className="text-xs text-[hsl(var(--muted))] text-center mt-6 leading-relaxed">
        Programaciones son aproximadas. Siempre confirmen en la web oficial antes de comprar.
      </p>
    </div>
  );
}
